import { useTranslation } from "react-i18next";
import { Suspense, useRef, useState } from "react";
import AppLoading from "../app-loading/app-loading";
import { Toast } from "primereact/toast";
import PosMovementSearch from "./pos-movement-search";
import { TabView, TabPanel } from "primereact/tabview";
import  SummaryTable  from "./pos-summary-datatable";
import { MovementLogTable } from "./pos-log-datatable";

const PosMovementMain = () => {
  const { t } = useTranslation();
  const toast = useRef<Toast>(null);
  const [loading, setLoading] = useState(false);
  const [logData, setLogData] = useState<any[]>([]);
  const [summaryData, setSummaryData] = useState<any[]>([]);
  const [posId, setPosId] = useState<number>(0);
  const [fromDate, setFromDate] = useState<any>(null);
  const [toDate, setToDate] = useState<any>(null);
  
  return (
    <>
      <Suspense fallback={<AppLoading />}>
        <Toast ref={toast} position="top-right" />
        <div className="layout-content mt-3 mb-3 grid grid-table-mobile">
          <div className="col-12">
            <h5 className="ml-1 mb-0">{t("POS Movements")}</h5>
          </div>
          <div className="col-12">
            <div className="flex align-items-center justify-content-between flex-wrap gap-2 w-full card-container mb-0">
              <PosMovementSearch  setLoading={setLoading}  onSearch={(data) => setLogData(data)} onSummary={(data) => setSummaryData(data)} setPosId={(posId) => setPosId(posId)} setFromDate={(startDate) => setFromDate(startDate)} setToDate={(endDate) => setToDate(endDate)}/>
            </div>
          </div >
          <div className="col-12">
          <TabView>
          <TabPanel header="Movement Log">
            <MovementLogTable data={logData} loading={loading} />
          </TabPanel>
          <TabPanel header="Summary View">
            <SummaryTable data={summaryData} loading={loading} posId={posId} startDate={fromDate} endDate={toDate}/>
          </TabPanel>
        </TabView>
            </div>
        </div>
        {loading && <AppLoading />}
      </Suspense>
    </>
  );
};

export default PosMovementMain;
